import { useQuery } from '@tanstack/react-query';

import { getDocumentOutput } from '@/services/data/DocumentsService';

/** Exact persisted output; chat invocation Markdown is never an authority after this read. */
export function useDocumentOutput({
  workspaceId,
  actorId,
  messageId,
  documentId,
  enabled,
}: {
  workspaceId?: string | null;
  actorId?: string | null;
  messageId?: string | null;
  documentId?: string | null;
  enabled: boolean;
}) {
  return useQuery({
    queryKey: ['document-output', workspaceId, actorId, messageId, documentId],
    enabled,
    queryFn: () => getDocumentOutput(messageId as string, documentId as string, actorId as string),
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
